export default __webpack_public_path__ + "static/media/barcode.2ee22371.svg";